import { render, staticRenderFns } from "./receivingAccountManagement.vue?vue&type=template&id=3249a547&scoped=true"
import script from "./receivingAccountManagement.vue?vue&type=script&lang=js"
export * from "./receivingAccountManagement.vue?vue&type=script&lang=js"
import style0 from "./receivingAccountManagement.vue?vue&type=style&index=0&id=3249a547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3249a547",
  null
  
)

export default component.exports